// Translator notes: Places, times and numbers written as digits (engine/src/rules/spatial.ts, time-expressions.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  spatialGap: {
    args: ['word'],
    fi: (a: string[]) => `Sanakirjassa ei ole valyrian sanaa ilmaukselle ”${a[0]}”, joten se on merkitty «näin». Sovellus ei arvaa sanaa.`,
    en: (a) => `The dictionary has no Valyrian word for “${a[0]}”, so it is marked «like this». The app does not guess one.`,
  },
  timeAgo: {
    args: ['word'],
    fi: (a: string[]) => `”${a[0]}” ajanilmauksen perässä on valyriassa jälkiasema sīrgō, ja aika on lokatiivissa (”kaksi päivää sitten”).`,
    en: (a) => `“${a[0]}” after a time is the postposition sīrgō in Valyrian, with the time in the locative (“two days ago”).`,
  },
  timeDuration: {
    args: [],
    fi: () => 'Kesto (”kolme vuotta”) on valyriassa lokatiivissa ilman omaa sanaa, kuten repliikissä ”paghyro jēdunna” = ne muutamat tunnit.',
    en: () => 'A length of time (“for three years”) is in the locative in Valyrian, with no word for “for”, as in “paghyro jēdunna” = for those few hours.',
  },
  calendarGap: {
    args: ['word'],
    fi: (a: string[]) => `Wikissä ei ole valyriankielisiä viikonpäivien eikä kuukausien nimiä, joten ”${a[0]}” on merkitty «näin».`,
    en: (a) => `The wiki has no Valyrian names for weekdays or months, so “${a[0]}” is marked «like this».`,
  },
  clockTime: {
    args: ['word'],
    fi: (a: string[]) =>
      `Wikissä ei ole tapaa kertoa kellonaikaa (vain nimettyjä hetkiä, kuten ”Masso Jēdunna” = lepakon hetkellä), joten ”${a[0]}” on merkitty «näin».`,
    en: (a) =>
      `The wiki has no way to tell the time by the clock (only named hours, such as “Masso Jēdunna” = in the Hour of the Bat), so “${a[0]}” is marked «like this».`,
  },
  digitNumeral: {
    args: ['word'],
    fi: (a: string[]) => `Luku ${a[0]} kirjoitettiin valyrian lukusanoilla.`,
    en: (a) => `The number ${a[0]} was written out with Valyrian numerals.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
